<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';

    @Component({
        props: {
            ActivePage: String,
            propStrategyId: String
        }
    })
    export default class CorporateNavigation extends Vue
    {
        get workspaceId() { return Number.parseInt(this.$route.params.workspaceId); }
        get strategyId() { return this.$route.params.strategyId ?? this.$props.propStrategyId; }
    }

</script>

<template>
    <nav class="navbar navbar-expand-lg fixed-top navbar-dark bg-dark" style="margin-bottom: 0;">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navBar" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navBar">
            <ul class="navbar-nav mr-auto">
                <li class="nav-item">
                    <a class="navbar-brand" v-sanitizedHref="`/#/strategy/portfolios/${workspaceId}/${strategyId}`">
                        Portfolios
                    </a>
                </li>

                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" data-toggle="dropdown">
                        Projects
                    </a>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" v-sanitizedHref="`/#/enterprise/projects/proposals/${workspaceId}/${strategyId}`">Proposals</a>
                        <a class="dropdown-item" v-sanitizedHref="`/#/enterprise/projects/scheduled/${workspaceId}/${strategyId}`">Scheduled</a>
                        <a class="dropdown-item" v-sanitizedHref="`/#/enterprise/projects/started/${workspaceId}/${strategyId}`">Started</a>
                        <a class="dropdown-item" v-sanitizedHref="`/#/enterprise/projects/finished/${workspaceId}/${strategyId}`">Finished</a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" v-sanitizedHref="`/#/enterprise/projects/all/${workspaceId}/${strategyId}`">All</a>
                    </div>
                </li>

                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" data-toggle="dropdown">
                        Manage
                    </a>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" v-sanitizedHref="`/#/enterprise/settings/${workspaceId}/${strategyId}`">Settings</a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" v-sanitizedHref="`/#/enterprise/attributes/${workspaceId}/${strategyId}`">Attributes</a>
                        <a class="dropdown-item" v-sanitizedHref="`/#/enterprise/resources/${workspaceId}/${strategyId}`">Resources</a>
                        <a class="dropdown-item" v-sanitizedHref="`/#/enterprise/revenues/${workspaceId}/${strategyId}`">Revenues</a>
                        <a class="dropdown-item" v-sanitizedHref="`/#/enterprise/costs/${workspaceId}/${strategyId}`">Costs</a>
                        <a class="dropdown-item" v-sanitizedHref="`/#/enterprise/capex/${workspaceId}/${strategyId}`">CAPEX</a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" v-sanitizedHref="`/#/enterprise/pnls/${workspaceId}/${strategyId}`">P&Ls</a>
                    </div>
                </li>

                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" data-toggle="dropdown">
                        Business case
                    </a>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" v-sanitizedHref="`/#/enterprise/business-case-templates/${workspaceId}/${strategyId}`">Templates</a>
                        <a class="dropdown-item" v-sanitizedHref="`/#/enterprise/metrics/${workspaceId}/${strategyId}`">Metrics</a>
                    </div>
                </li>

                <li class="nav-item">
                    <a class="nav-link" v-sanitizedHref="`/#/enterprise/planning/${workspaceId}/${strategyId}`">Planning</a>
                </li>

                <!--<li class="nav-item">
        <a class="nav-link" v-sanitizedHref="``">Stakeholders</a>
    </li>
    <li class="nav-item">
        <a class="nav-link" v-sanitizedHref="``">Risks</a>
    </li>
    <li class="nav-item">
        <a class="nav-link" v-sanitizedHref="``">Decisions</a>
    </li>-->
            </ul>

            <ul class="navbar-nav">
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" data-toggle="dropdown">
                        Account
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" v-sanitizedHref="`/#/projects/${workspaceId}`">Back to workspace</a>
                        <a class="dropdown-item" href="/#/organizations/users/dashboard">My dashboard</a>
                        <a class="dropdown-item" v-sanitizedHref="`/#/organizations/users/account`">Manage your account</a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" v-sanitizedHref="`/organizations/sessions/close`">Sign out</a>
                    </div>
                </li>
            </ul>
        </div>
    </nav>
</template>

<style scoped>
    a.nav-link {
        color: #bbb !important;
    }

        a.nav-link:hover {
            color: #fff !important;
        }

    .navbar {
        -webkit-box-shadow: 0 2px 6px 0 #999;
        -moz-box-shadow: 0 2px 6px 0 #999;
        box-shadow: 0 2px 6px 0 #999;
    }

</style>